export const MDM_SOFTWARE = {
  TITLE: 'Software',
  SEARCH_PLACEHOLDER: 'Buscar software...',
  TOTAL_SOFTWARE: 'software',
  NO_SOFTWARE: 'No hay software disponible',
  NO_RESULTS: 'No se encontró software',
  ADD_CUSTOM_PACKAGE: 'Añadir paquete personalizado',
  ADD_FROM_CATALOG: 'Añadir desde el catálogo',
  ORGANIZATION_SUBTITLE: 'Tu lista de software aprobado. Instálalo en los hosts desde aquí',
  CATALOG_SUBTITLE: 'Software verificado por Qalea. Añade el que usa tu equipo a la lista aprobada',
  APPROVED_TOOLTIP: 'Este software está aprobado por tu organización',
}

export const MDM_SOFTWARE_TABS = {
  TEAM_SOFTWARE: 'Software de la organización',
  FLEET_CATALOG: 'Catálogo de Qalea',
}

export const MDM_SOFTWARE_FILTERS = {
  STATUS: 'Estado',
  PLATFORM: 'Plataforma',
  CLEAR_FILTERS: 'Limpiar',
}

export const MDM_SOFTWARE_PLATFORM = {
  MACOS: 'macOS',
  WINDOWS: 'Windows',
  LINUX: 'Linux',
  IOS: 'iOS',
  ANDROID: 'Android',
  ALL: 'Todas las plataformas',
}

export const MDM_SOFTWARE_STATUS = {
  INSTALLED: 'Instalado',
  NOT_INSTALLED: 'No instalado',
  IN_APPROVED_LIST: 'En la lista aprobada',
  NOT_IN_APPROVED_LIST: 'No está en la lista aprobada',
  PENDING: 'Pendiente',
  FAILED: 'Fallido',
}

export const MDM_SOFTWARE_DRAWER = {
  TITLE: 'Detalles del Software',
  STATUS: 'Estado',
  NOT_INSTALLED_STATUS: 'No instalado',
  PLATFORM: 'Plataforma',
  SOURCE: 'Fuente',
  SOURCE_SOFTWARE_CATALOG: 'Catálogo de Qalea',
  SOURCE_ORGANIZATION_CATALOG: 'Catálogo de la Organización',
  PACKAGE_TYPE: 'Tipo de Paquete',
  INSTALLED_GROUPS: 'Instalado en',
  AVAILABLE_GROUPS: 'Disponible en',
  AVAILABLE_GROUPS_INFO:
    'Ofrecida en la Play Store de trabajo de los teléfonos de estos grupos. Cada persona la instala desde allí.',
  INSTALLED_GROUPS_INFO: 'Grupos con hosts que tienen este software instalado, o donde falló su instalación.',
  GROUPS: (count: number) => `Grupos (${count})`,
  NOT_INSTALLED: 'No instalado en ningún grupo',
  HOSTS_INSTALLED: (count: number) => `${count} instalados`,
  HOSTS_PENDING: (count: number) => `${count} pendientes`,
  HOSTS_FAILED: (count: number) => `${count} fallidos`,
  INSTALL: 'Instalar',
  UPDATE: 'Actualizar',
  UNINSTALL: 'Desinstalar',
  OTHER_HOSTS: (count: number) => `Otros hosts (${count})`,
  OTHER_HOSTS_DESCRIPTION: 'Hosts que tienen este software instalado pero no forman parte de ningún grupo gestionado.',
  INSTALL_DETAILS: 'Detalles de instalación',
  INSTALL_SCRIPT_OUTPUT: 'Salida del script de instalación',
  PRE_INSTALL_QUERY_OUTPUT: 'Salida de la consulta previa',
  POST_INSTALL_SCRIPT_OUTPUT: 'Salida del script posterior',
  NO_OUTPUT: 'Sin salida',
  RETRY_INSTALLATION: 'Reintentar instalación',
  HOST_STATUS: {
    INSTALLED: 'Instalado',
    PENDING: 'Pendiente',
    FAILED: 'Fallido',
    AVAILABLE: 'Disponible',
    NOT_INSTALLED: 'No instalado',
  },
}

export const MDM_SOFTWARE_CARD = {
  UPDATE: 'Actualizar',
  UNINSTALL: 'Desinstalar',
  INSTALLING: 'Instalando',
  UNINSTALLING: 'Desinstalando',
  INSTALLING_ON_HOSTS: (count: number) => `Instalando en ${count} ${count === 1 ? 'host' : 'hosts'}`,
  UNINSTALLING_FROM_HOSTS: (count: number) => `Desinstalando de ${count} ${count === 1 ? 'host' : 'hosts'}`,
  INSTALLING_ON_SHORT: (count: number) => `Instalando en ${count}…`,
  UNINSTALLING_FROM_SHORT: (count: number) => `Desinstalando de ${count}…`,
  RETRY: 'Reintentar',
  INSTALL: 'Instalar',
  STATUS_GETTING: 'Obteniendo estado…',
  STATUS_NOT_INSTALLED: 'No instalado',
  STATUS_PENDING_ON_HOSTS: (count: number) => `Pendiente en ${count} ${count === 1 ? 'host' : 'hosts'}`,
  STATUS_INSTALLED_ON_HOSTS: (count: number) => `Instalado en ${count} ${count === 1 ? 'host' : 'hosts'}`,
  STATUS_FAILED_ON_HOSTS: (count: number) => `Falló en ${count} ${count === 1 ? 'host' : 'hosts'}`,
  STATUS_FAILED_INFO:
    'La última instalación en estos hosts falló. Abre un host fallido para ver el motivo y reintentar.',
  STATUS_INSTALLED_OF: (installed: number, total: number) => `${installed} de ${total} instalados`,
  ADD_TO_APPROVED_LIST: 'Añadir a la lista aprobada',
  IN_APPROVED_LIST: 'En la lista aprobada',
}

export const MDM_SOFTWARE_DIALOG = {
  VERSION: 'Versión',
  INSTALL_COMPLETE: 'La instalación ha sido encolada.',
  INSTALL_DESCRIPTION: 'Selecciona los grupos donde quieres instalar este software.',
  UNINSTALL_COMPLETE: 'La desinstalación ha sido encolada.',
  UNINSTALL_DESCRIPTION: 'Selecciona los grupos donde quieres desinstalar este software.',
  SEARCH_GROUPS: 'Buscar grupos...',
  DONE: 'Listo',
  CANCEL: 'Cancelar',
  INSTALLING: 'Encolando...',
  INSTALL: 'Instalar',
  UNINSTALLING: 'Encolando...',
  UNINSTALL: 'Desinstalar',
  HOSTS: 'hosts',
  ALL_HOSTS_IN_GROUP: 'Todos los hosts en este grupo',
  SUCCESS: 'Éxito',
  QUEUED: 'Encolado',
  ERROR: 'Error',
  NOT_APPROVED_TITLE: 'Software No Aprobado',
  NOT_APPROVED_MESSAGE: 'Este software no está en la lista de Software Aprobado de tu organización.',
  APPROVE_FOR_ORG: 'Aprobar para la Organización',
  APPROVE_CHECKBOX: 'Añadir a la lista de Software Aprobado antes de instalar',
  APPROVING: 'Aprobando...',
  LOADING_INSTALLED_GROUPS: 'Cargando grupos instalados...',
  INSTALLED_GROUPS_ERROR: 'Error al cargar los grupos instalados. Inténtalo de nuevo.',
}

export const MDM_SOFTWARE_FORM = {
  TITLE: 'Añadir Software',
  MODE_PACKAGE: 'Paquete',
  MODE_PLAY_STORE: 'App de Play Store',
  APPLICATION_ID: 'ID de aplicación',
  APPLICATION_ID_PLACEHOLDER: 'com.android.chrome',
  APPLICATION_ID_HELP: 'El ID al final de la URL de la app en Google Play Store.',
  TARGET_GROUPS: 'Grupos',
  NO_ANDROID_GROUPS: 'Todavía no hay grupos de Android. Crea uno antes de añadir una app de Play Store.',
  ANDROID_PUBLISH_HELP:
    'La app se publica en la Play Store del perfil de trabajo de cada móvil de estos grupos, donde el empleado la instala.',
  NAME: 'Nombre',
  VERSION: 'Versión',
  PLATFORM: 'Plataforma',
  PACKAGE_TYPE: 'Tipo de Paquete',
  SELECT_PACKAGE_TYPE: 'Selecciona el tipo de paquete',
  PACKAGE_FILE: 'Archivo del Paquete',
  UPLOAD_PACKAGE: 'Subir Paquete',
  WEBSITE: 'Sitio Web (opcional)',
  INSTALL_SCRIPT: 'Script de instalación (opcional)',
  UNINSTALL_SCRIPT: 'Script de desinstalación (opcional)',
  CREATE_SOFTWARE: 'Añadir Software',
  CANCEL: 'Cancelar',
}

export const MDM_SOFTWARE_MESSAGES = {
  CREATED: 'Software creado correctamente',
  FAILED_TO_CREATE: 'Error al crear el software',
  ADDED_TO_APPROVED_LIST: (name: string) => `${name} añadido a la lista aprobada`,
  FAILED_TO_ADD_TO_APPROVED_LIST: 'Error al añadir a la lista aprobada',
}
